import Flex from '@/elements/Flex'
import { useParams } from 'react-router'
import useBreakpoints from '@/hooks/useBreakpoints'

import IndividualInnerCircle from './IndividualInnerCircle'
import IndividualDelegates from './IndividualDelegates'

function IndividualAssignments() {
  const { id: individualIdParam } = useParams<{ id: string }>()
  const individualId = individualIdParam || ''

  const { isTablet, isMobile } = useBreakpoints()

  return (
    <Flex
      wfull
      className='card'
      align='flex-end'
      gap={8}
      p={isMobile ? 3 : isTablet ? 5 : 7}
    >
      <IndividualDelegates individualId={individualId} />
      <Flex color='gray-light-20' wfull style={{ height: '1px' }} />
      <IndividualInnerCircle individualId={individualId} />
    </Flex>
  )
}

export default IndividualAssignments
